import { Resource } from 'constants/resources';

import { useMemo } from 'react';

import clsx from 'clsx';
import { usePermissions } from 'hooks/usePermissions';
import {
  MenuItemLink as RAMenuItemLink,
  MenuItemLinkProps as RAMenuItemLinkProps,
} from 'react-admin';
import { useLocation } from 'react-router-dom';
import { Permission } from 'types/embedded/permission';

import { getActiveMenuPath } from './utils/getActiveMenuPath';

export type MenuItemLinkProps = {
  resource: Resource;
} & RAMenuItemLinkProps;

export const MenuItemLink: React.FC<MenuItemLinkProps> = ({
  resource,
  className,
  ...restProps
}) => {
  const { hasResourceAccess, hasResourcePermissions, permissions } = usePermissions();
  const { pathname } = useLocation();
  const permissionKeys = useMemo(
    () => Object.keys(permissions).map((permission) => permission.replace('/admin', '')),
    [permissions],
  );

  if (
    !hasResourceAccess(resource) ||
    !hasResourcePermissions(resource, [Permission.Full, Permission.Read])
  ) {
    return null;
  }

  return (
    <RAMenuItemLink
      className={clsx(className, {
        'RaMenuItemLink-active_custom':
          getActiveMenuPath(pathname, permissionKeys) === '/' + resource,
      })}
      {...restProps}
    />
  );
};
